'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.Router;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/Router.js
// module id = 1691
// module chunks = 0